import '../../../../../types/product.js';
import { isSubscriptionPurchase } from '../../../../../types/typeguards.js';

const mapSolutionToDraftLineItem = ({ sku , state , purchaseType  })=>{
    const { deliveryInterval  } = state.configurations.subscriptionPurchaseConfigurations;
    const lineItemDraft = {
        sku,
        quantity: state.configurations.quantity,
        type: 'regular'
    };
    if (isSubscriptionPurchase(purchaseType)) {
        if (!deliveryInterval) {
            return;
        }
        lineItemDraft.typeDetails = {
            isSubscription: true,
            subscriptionDetails: {
                deliveryInterval
            }
        };
    }
    return lineItemDraft;
};

export { mapSolutionToDraftLineItem };
//# sourceMappingURL=map-solution-to-draft-line-item.js.map
